module.exports = __webpack_public_path__ + "static/amazon-dfa4816551e0be65c863b2f3e976ec7c.jpg";